import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'

import logs from './modules/logs'
import user from './modules/user'
import surgeries from './modules/surgeries'
import auth from './modules/auth'
import courses from './modules/courses'
import events from './modules/events'
import contacts from './modules/contacts'
import internships from './modules/internships'
import scientificActivities from './modules/scientific-activities'
import otherActivities from './modules/other-activities'
import notifications from './modules/notifications'
import workplaces from './modules/workplaces'
import vuexOrmDb from './vuex-orm'

Vue.use(Vuex)

const database = vuexOrmDb()

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],
  state: {
    snackbar: {
      show: false,
      text: '',
      color: ''
    },
    langValue: 'pt',
    langs: ['en', 'pt']
  },
  getters: {
    snackbar: state => state.snackbar,
    langValue: state => state.langValue,
    langs: state => state.langs
  },
  mutations: {
    setSnackbar(state, snackbar) {
      state.snackbar = snackbar
    },
    setLangValue(state, langValue) {
      state.langValue = langValue
    }
  },
  actions: {
    showSuccessSnackbar({ commit }, text) {
      const snackbar = { show: true, text: text, color: 'success' }
      commit('setSnackbar', snackbar)
    },
    showErrorSnackbar({ commit }, text) {
      const snackbar = { show: true, text: text, color: 'error' }
      commit('setSnackbar', snackbar)
    },
    displaySnackbar({ commit, state }, display) {
      const snackbar = { ...state.snackbar }
      snackbar.show = display
      commit('setSnackbar', snackbar)
    },
    setLangValue({ commit }, langValue) {
      commit('setLangValue', langValue)
    }
  },
  modules: {
    logs,
    internships,
    user,
    surgeries,
    auth,
    courses,
    scientificActivities,
    events,
    contacts,
    otherActivities,
    notifications,
    workplaces
  }
})
